import React from "react";
import "./errorpage.css";
import CollapsibleExample from "../../components/Navbar";
import Yh from "./../../assets/booking-img/yH.png";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <div className="error-page-container">
      <CollapsibleExample />
      <div className=" ">
        <div className="error-page-wrapper ">
          <div className="error-image">
            <img src={Yh} alt="" />
          </div>
          <div className="error-page-content">
            <h1>Не знайшли, що шукали?</h1>
            <div className=" d-flex flex-column gap-2">
              <p>
                {" "}
                Вибачте, але здається, під час обробки вашого запиту сталася
                помилка. Код помилки: 500.
              </p>
              <p>
                Можете спробувати оновити сторінку, перевірити підключення до
                Інтернету, або повернутися на головну
              </p>
            </div>

            <button onClick={() => navigate("/")}>На головну сторінку</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
